import { Form } from "antd";
import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface MobileProps {
  visible: boolean;
  value?: string;
  onChange?: (values: {
    number: string;
    country_code: string;
    country_short_code: string;
  }) => void;
}

const Mobile: React.FC<MobileProps> = ({ visible, value, onChange }) => {
  const handleChange = (value: string, data: any) => {
    if (onChange) {
      onChange({
        number: value.length > 10 ? value.slice(2) : value,
        country_code: data.country_code,
        country_short_code: data.dialCode,
      });
    }
  };
  return (
    <Form.Item
      name="mobile"
      label="Mobile"
      rules={[
        {
          required: true,
          message: "Mobile number is required",
        },
      ]}
    >
      <PhoneInput
        country="in"
        disabled={!visible}
        inputStyle={{
          backgroundColor: visible ? "#fff" : "#ebebeb",
          width: "auto",
        }}
        buttonStyle={{
          backgroundColor: visible ? "#fff" : "#ebebeb",
        }}
        value={value}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default Mobile;
